import * as actionTypes from "./types";

const INITIAL_STATE = {
  current: {},
  loading: false,
  isLoggedIn: false,
  shopProfile: {},
  notifications: [],
  waiting: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOADING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FAILED_REQUEST:
      return INITIAL_STATE;

    case actionTypes.LOGIN_SUCCESS:
      return {
        current: action.payload,
        loading: false,
        isLoggedIn: true,
      };
    case actionTypes.SHOP_PROFILE:
      return {
        ...state,
        // shopProfile: { ...state?.shopProfile, ...action.payload }
        shopProfile: action.payload,
      }

    case actionTypes.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload
      }
    case actionTypes.ADD_NOTIFICATIONS:
      return {
        ...state,
        notifications: [...action.payload, ...state.notifications]
      }
    case actionTypes.WAITING_TRUE:
      return {
        ...state,
        waiting: true,
      };
    case actionTypes.WAITING_FALSE:
      return {
        ...state,
        waiting: false,
      };
    case actionTypes.LOGOUT_SUCCESS:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default authReducer;
